<app-breadcrumb  [master]="'Analizy'" [parentName]="'Przepięcia polis'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-commission-redirections-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

    <app-dict-insurance-companies
      [multiple]="true" label="TU" class="report-commission-redirections-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany"
      name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="false"
      label="Firma" class="report-commission-redirections-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-ofwcas
      [multiple]="false"
      label="OFWCA zawierająca polisę" class="report-commission-redirections-list-filter"
      [(ngModel)]="initialFilters.ofwca"
      name="ofwca"
    ></app-dict-ofwcas>

    <mat-form-field
      class="report-commission-redirections-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="contains$policyNumber" [(ngModel)]="initialFilters.contains$policyNumber">
    </mat-form-field>

    <mat-form-field class="report-commission-redirections-list-filter">
      <mat-label>Nazwa klienta</mat-label>
      <input matInput placeholder="Nazwa klienta" name="contains$customerName" [(ngModel)]="initialFilters.contains$customerName">
    </mat-form-field>

    <app-datepicker
      class="report-commission-redirections-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$concludeDate" name="gte$concludeDate"
    ></app-datepicker>

    <app-datepicker
      class="report-commission-redirections-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$concludeDate" name="lte$concludeDate"
    ></app-datepicker>

    <app-dict-ofwcas
      [multiple]="false"
      label="OFWCA na którą przepinamy" class="report-commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newOfwca"
      name="newOfwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="report-commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newPartner" name="newPartner"
    ></app-dict-partners>

    <app-dict-regionals
      [multiple]="true" label="Regionalny (majątek) Partnera"
      class="report-commission-redirections-list-filter"
      [(ngModel)]="initialFilters.newPartnerAssetsRegional" name="newPartnerAssetsRegional"
    ></app-dict-regionals>

    <mat-form-field class="report-commission-redirections-list-filter">
      <mat-label>Stawka % Partner od</mat-label>
      <input matInput placeholder="Stawka % Partner od" name="gte$ratePaid" [(ngModel)]="initialFilters.gte$ratePaid">
    </mat-form-field>

    <mat-form-field class="report-commission-redirections-list-filter">
      <mat-label>Stawka % Partner do</mat-label>
      <input matInput placeholder="Stawka % Partner do" name="lte$ratePaid" [(ngModel)]="initialFilters.lte$ratePaid">
    </mat-form-field>

    <mat-form-field class="report-commission-redirections-list-filter">
      <mat-label>Przypis od</mat-label>
      <input matInput placeholder="Stawka % Partner od" name="gte$assign" [(ngModel)]="initialFilters.gte$assign">
    </mat-form-field>

    <mat-form-field class="report-commission-redirections-list-filter">
      <mat-label>Przypis do</mat-label>
      <input matInput placeholder="Stawka % Partner do" name="lte$assign" [(ngModel)]="initialFilters.lte$assign">
    </mat-form-field>

  </form>

  <div class="report-commission-redirections-list-buttons">
    <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
</div>
